import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Label, Check,
	Text, Indicator,
} from './checkboxStyles';

import { randomNumber } from '../helpers';

class Checkbox extends PureComponent {
	render () {
		const { children, ...rest } = this.props;
		const id = randomNumber();
		return (
			<Label htmlFor={id}>
				<Check id={id} {...rest} />
				<Indicator />
				<Text>
					{ children }
				</Text>
			</Label>
		);
	}
}

Checkbox.propTypes = {
	children: PropTypes.node,
};

export default Checkbox;
